import { actionLogout } from '../../module/LoginModule';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import { actionSmsSend } from '../../module/body/sms/SmsSendModule';
import { useDispatch } from 'react-redux';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import { actionSessionExtend } from '../../module/LoginModule';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';

const SessionExtendModal = ({ modalRef }) => {
    const dispatch = useDispatch();

    const handleConfirm = () => {
        dispatch(actionSessionExtend());
        modalRef.current.close();
    };

    const handleLogout = () => {
        dispatch(actionLogout({ data: { forceLogout: true }, msg: '로그아웃 하였습니다' }));
        modalRef.current.close();
    };

    return (
        <>
            <ModalHeader title={'로그인 연장'} modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner'>
                    <div className='info-txt'>
                        <div style={{ marginTop: 4 }}>
                            60분동안 서비스 이용이 없으신 경우 로그아웃 처리 됩니다. 로그인을 유지하려면 연장하기 버튼을
                            눌러주세요. 1분 뒤 자동 로그아웃 처리 됩니다.
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='로그아웃' onClick={() => handleLogout()} />
                    <ConfirmButtonBox title='연장하기(60분)' onClick={() => handleConfirm()} />
                </div>
            </div>
        </>
    );
};

export default SessionExtendModal;
